export default __webpack_public_path__ + "static/media/08_vyrobky-min.9d879bd0.jpg";